<button
  type="button"
  class="ut-btn ut-btn--secondary ut-btn--sm pin"
  [class.is-on]="pinned"
  [attr.aria-label]="label"
  [attr.aria-busy]="state.busy()"
  [class.hover-locked]="state.hoverLocked()"
  (mouseleave)="state.unlockHover()"
  (click)="toggle()">
  <span class="action__slot">
    <span class="action__idle" [class.is-shown]="!pinned && !state.loading()">
      <svg class="material-icons action__icon pin__icon" viewBox="0 -960 960 960" aria-hidden="true"><path fill="currentColor" [attr.d]="keepPath"/></svg>
      Pin
    </span>
    <span class="action__done" [class.is-shown]="pinned && !state.loading()">
      <span class="action__rest">
        <svg class="material-icons action__icon pin__icon" viewBox="0 -960 960 960" aria-hidden="true"><path fill="currentColor" [attr.d]="keepPath"/></svg>
        Pinned
      </span>
      <span class="action__hover">
        <svg class="material-icons action__icon pin__icon" viewBox="0 -960 960 960" aria-hidden="true"><path fill="currentColor" [attr.d]="keepOffPath"/></svg>
        Unpin
      </span>
    </span>
    <span class="action__loading" [class.is-shown]="state.loading()" aria-hidden="true">
      <span class="action__dots"><i></i><i></i><i></i></span>
    </span>
  </span>
</button>
<span class="sr-only" aria-live="polite">{{ state.announcement() }}</span>
